import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.977 7c.026.001.649.039 1.316.707a.999.999 0 1 0 1.414-1.414A4.491 4.491 0 0 0 6 5.2V5a1 1 0 1 0-2 0v.185A2.995 2.995 0 0 0 2 8c0 2.281 1.727 2.713 2.758 2.971C5.873 11.249 6 11.354 6 12c0 .552-.448 1-.976 1-.026-.001-.65-.04-1.317-.707a.999.999 0 1 0-1.414 1.414A4.506 4.506 0 0 0 4 14.8v.2a1 1 0 1 0 2 0v-.185A2.993 2.993 0 0 0 8 12c0-2.281-1.726-2.713-2.757-2.971C4.128 8.751 4 8.646 4 8c0-.551.449-1 .977-1zM17 13h-3.585l.292-.293a.999.999 0 1 0-1.414-1.414l-2 1.999a.988.988 0 0 0-.215.326.992.992 0 0 0 0 .764c.05.123.124.234.216.326l1.999 1.999a1 1 0 0 0 1.414-1.414L13.415 15H17a1 1 0 1 0 0-2zm-7-7a1 1 0 0 1 1-1h3.586l-.293-.293a1 1 0 0 1 1.414-1.414l1.999 1.999a.985.985 0 0 1 .217.326.992.992 0 0 1 0 .764.985.985 0 0 1-.217.326l-2 1.999a.997.997 0 0 1-1.413 0 1 1 0 0 1 0-1.414L14.586 7H11a1 1 0 0 1-1-1z"
});

var SvgCurrencyConvertMinor = function SvgCurrencyConvertMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCurrencyConvertMinor as S };
